import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import EventEmitter from "eventemitter3";
import "./index.css";

var calories;
window.ee = new EventEmitter();

const Add = () => {
  const [weight, setWeight] = useState(true);
  const [age, setAge] = useState(true);
  const [heigth, setHeigth] = useState(true);

  const weightRef = useRef(null);

  useEffect(() => {
    weightRef.current.focus();
  }, []);

  const onBtnClickHandler = e => {
    e.preventDefault();

    //=((9,99*weigth+6,25*heigth-4,92*age-161)*1,375)*0,85 - formula

    calories =
		(447.6 + (9.2 * weight) + (3.1 * heigth) - (4.3 * age));
		  //(9.99 * weight + 6.25 * heigth - 4.92 * age - 161) * 1.375 * 0.85;
    calories = Math.round(calories);
    window.ee.emit("Input_finished", calories);
  };

  return (
    <div className="temp">
      <div className="columns is-centered is-mobile test">
        <div className="field column is-one-fifth-desktop is-one-third-mobile">
          <label className="label has-text-centered">Вес</label>
          <div className="control">
            <input
              type="text"
              className="add__weigth input"
              onChange={e => setWeight(e.target.value)}
              placeholder="Ваш вес"
              ref={weightRef}
            />
          </div>
        </div>
        <div className="field column is-one-fifth-desktop  is-one-third-mobile">
          <label className="label has-text-centered">Возраст</label>
          <div className="control">
            <input
              type="text"
              className="add__age input"
              onChange={e => setAge(e.target.value)}
              placeholder="Ваш возраст"
            />
          </div>
        </div>
        <div className="field column is-one-fifth-desktop  is-one-third-mobile">
          <label className="label has-text-centered">Рост</label>
          <div className="control">
            <input
              type="text"
              className="add__heigth input "
              onChange={e => setHeigth(e.target.value)}
              placeholder="Ваш рост"
            />
          </div>
        </div>
      </div>

      <div className="has-text-centered">
        <button
          type="button"
          className="add__btn button is-primary has-text-centered is-medium"
          onClick={onBtnClickHandler}
        >
          Рассчитать КБЖУ
        </button>
      </div>
    </div>
  );
};

const Output = () => {
  const [output_calories, setOutput_calories] = useState("");
  const [carbs, setCarbs] = useState("");
  const [proteins, setProteins] = useState("");
  const [fat, setFat] = useState("");

  useEffect(() => {
    window.ee.addListener("Input_finished", function(calories) {
      setOutput_calories(calories);
      setCarbs(Math.round(calories * 0.1));
      setProteins(Math.round(calories / 16));
      setFat(Math.round((calories * 0.35) / 9));
    });
    return () => {
      window.ee.removeListener("Input_finished");
    };
  }, []);

  return (
    <table className="table is-striped is-size-6	center-table">
      <tbody>
        <tr>
          <td>Ваша норма калорий: </td>
          <td>
            <span>{output_calories}</span>
          </td>
        </tr>

        <tr>
          <td>Ваша норма белков: </td>
          <td>
            <span>{proteins}</span>
          </td>
        </tr>

        <tr>
          <td>Ваша норма жиров: </td>
          <td>
            <span>{fat}</span>
          </td>
        </tr>

        <tr>
          <td>Ваша норма углеводов: </td>
          <td>
            <span>{carbs}</span>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

ReactDOM.render(
  <div>
    <Add />
    <Output />
  </div>,
  document.getElementById("root")
);
